import PropTypes from 'prop-types';
import React from 'react';

import Text, { ENUM_COLORS, ENUM_FONTS } from '@commons/Text';

import { Cell, LinkIcon, Row } from './styledComponents';

const NextOrderRow = (props) => {
  const { columns, order, link, withLink } = props;

  const handleOpenLink = () => {
    window.open(link);
  };

  return (
    <Row>
      {withLink && <Cell>{!!link && <LinkIcon onClick={handleOpenLink} />}</Cell>}
      {columns.map(({ id, propertyKey, render }) => (
        <Cell key={id}>
          {render ? (
            render(order[propertyKey], order)
          ) : (
            <Text color={ENUM_COLORS.DARKEST} font={ENUM_FONTS.TEXT_SMALL_HEIGHT_16}>
              {order[propertyKey] ?? '-'}
            </Text>
          )}
        </Cell>
      ))}
    </Row>
  );
};

NextOrderRow.propTypes = {
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      propertyKey: PropTypes.string.isRequired,
      render: PropTypes.func,
    }),
  ).isRequired,
  order: PropTypes.objectOf(PropTypes.any).isRequired,
  link: PropTypes.string,
  withLink: PropTypes.bool,
};

NextOrderRow.defaultProps = {
  link: null,
  withLink: false,
};

export default NextOrderRow;
